import {Chip} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import {Group} from 'src/design/atoms/Group';
import {DateInput} from '@mantine/dates';
import React, {useMemo} from 'react';
import type {DatePreset} from 'src/design/atoms/datePresets';
import { resolvePresetToDate} from 'src/design/atoms/datePresets';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormDatePickerV2Props {
  field: IFormFieldV2;
  value: string | null;
  error?: string;
  onChange: (name: string, value?: string) => void;
  presets?: DatePreset[];
}

const minDate = new Date(1901, 1, 1);
const maxDate = new Date(2999, 12, 31);

export const FormDatePickerV2 = React.memo<FormDatePickerV2Props>(
  ({field, value, error, onChange, presets}: FormDatePickerV2Props) => {
    const dateValue = useMemo(
      () => (value ? new Date(String(value)) : null),
      [value]
    );

    return (
      <Box>
        <DateInput
          data-testid={`form-field-${field.name}`}
          label={field.label}
          description={field.description}
          error={error}
          value={dateValue}
          onChange={date => onChange(field.name, date?.toString().toShortDate())}
          withAsterisk={field.required}
          clearable={!field.required}
          valueFormat="MM/DD/YYYY"
          minDate={minDate}
          maxDate={maxDate}
          disabled={field.disabled}
        />
        {presets && (
          <Group gap="xs" mt={4}>
            {presets.map(preset => (
              <Chip
                key={preset.value}
                size="xs"
                variant="outline"
                checked={false}
                onChange={() =>
                  onChange(field.name, resolvePresetToDate(preset.value).toString().toShortDate())
                }>
                {preset.label}
              </Chip>
            ))}
          </Group>
        )}
      </Box>
    );
  }
);
